import React from 'react';

import { useMutation } from '@apollo/client';

import Toast from '../../../components/Toast/Toast';
import affairesQueries from '../../../services/affaires/affaires';
import AssignmentContext from './assignment.context';

const RejectLeadButton = props => {
  const [rejectAssignment, rejectAssignmentMutation] = useMutation(
    affairesQueries.Mutation.rejectOpportunityAssignment,
  );
  const { taken, rejected, setRejected } = React.useContext(AssignmentContext);
  const opportunityTaken = props?.lead?.taken || taken;
  const opportunityRejected = props?.lead?.rejected || rejected;

  const onClick = async () => {
    try {
      await rejectAssignment({
        variables: {
          opportunityAssignmentId: props.lead.id,
        },
      });
      setRejected(true);
    } catch (e) {
      console.warn('error while creating affaire', e);
    }
  };

  const assignment = {
    rejected: !rejectAssignmentMutation?.data?.rejectOpportunityAssignmentId,
  };

  return (
    <span>
      {assignment.rejected && !opportunityTaken && !opportunityRejected && (
        <button className='btn btn-danger mt-2 btn-block' type='button' onClick={onClick}>
          <span>
            {rejectAssignmentMutation.loading && (
              <span className='spinner-border spinner-border-sm' role='status' aria-hidden='true'>
                {' '}
              </span>
            )}
            &nbsp;&nbsp;Je refuse
          </span>
        </button>
      )}
      {rejectAssignmentMutation.error && <Toast error={rejectAssignmentMutation.error.message} />}
    </span>
  );
};

export default RejectLeadButton;
